module.exports = __webpack_public_path__ + "img/2021_1_14_dog_floater.9ff16749.jpg";